module.exports = __webpack_public_path__ + "static/media/face_anxious.46cbb5ce.svg";